export const moibleMedia = '@media screen and (max-width: 479px)'
export const tabletMedia = '@media screen and (max-width: 1023px)'
